import { IFilterFunction } from '@move-frontend/utils';
import { SuggestionStore } from './SuggestionStore';
import { IFlightSearchSuggestion } from '../models/IFlightSearchSuggestion';
import { normalizeSearchValue } from '../../../shared/normalizeSearchValue';

export function createFlightSuggestionsFilter(
	suggestionStore: SuggestionStore<IFlightSearchSuggestion>,
) {
	const includesQuery: IFilterFunction<IFlightSearchSuggestion> = (
		suggestion: IFlightSearchSuggestion,
	) => {
		const query = normalizeSearchValue(suggestionStore.query);
		const option = normalizeSearchValue(suggestion.value);

		return option.includes(query);
	};

	return { includesQuery };
}
